import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import OpportunityMobile from './OpportunityMobile';
import OpportunityDesktop from './OpportunityDesktop';

function Opportunity({ app, config, filter }) {
    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });

    return isMobile ? <OpportunityMobile app={app} config={config} filter={filter} />
        : <OpportunityDesktop app={app} config={config} filter={filter} />;
}

Opportunity.defaultProps = {
    app: null,
    config: {},
    filter: ""
};

Opportunity.propTypes = {
    app: PropTypes.object,
    config: PropTypes.object,
    filter: PropTypes.string
};

export default Opportunity;
